<div class="person-events-page">
  <div class="content-container">
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="errorMessage && !isLoading" class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <p>{{ errorMessage }}</p>
    </div>

    <ng-container *ngIf="!isLoading && !errorMessage && person">
      <div class="table-toolbar-row">
        <app-table-surface
          title="Eventos"
          titleIcon="history"
          [columns]="columns"
          [data]="filteredEvents"
          [enableRowHover]="false"
          [noDataMessage]="'Esta persona todavía no tiene eventos cargados para el filtro seleccionado.'"
          [tableHeight]="'100%'"
          [cellTemplate]="cellContent"
          [rowDetailTemplate]="eventMovementsDetail"
          [expandedRow]="expandedEvent"
          [activeFilters]="activeFilterChips"
          [enableSearch]="true"
          searchPlaceholder="Buscar actividad..."
          [enableFilter]="true"
          [enableSort]="true"
          [sortState]="currentSort"
          [enableColumnVisibility]="true"
          [enableDensity]="true"
          [viewOptions]="[
            { value: 'table', icon: 'table_rows', label: 'Tabla' },
            { value: 'timeline', icon: 'timeline', label: 'Timeline' }
          ]"
          [activeView]="viewMode"
          [customViewTemplate]="timelineView"
          [primaryActionLabel]="(canManageMembers || canManageMinisterialActivity) ? 'Nuevo' : undefined"
          [primaryActionOptions]="(canManageMembers || canManageMinisterialActivity) ? primaryActionOptions : []"
          [readonly]="!(canManageMembers || canManageMinisterialActivity)"
          tableId="person-events-page"
          (searchChange)="onToolbarSearch($event)"
          (filterRemove)="onFilterRemove($event)"
          (toolbarSortChange)="onToolbarSort($event)"
          (viewChange)="setViewMode($event)"
          (primaryActionOptionClick)="onPrimaryActionOption($event)">
          <a
            toolbarTitleActions
            mat-icon-button
            class="events-back-button"
            [routerLink]="personProfilePath"
            aria-label="Volver a la ficha de la persona"
            title="Volver a la ficha de la persona">
            <mat-icon>arrow_back</mat-icon>
          </a>
          <div filterPanel class="filters-form" [formGroup]="filterForm">
            <div class="filter-row filter-row--search">
              <app-date-range-picker
                class="date-range-field"
                label="Fecha"
                startPlaceholder="DD/MM/AAAA"
                endPlaceholder="DD/MM/AAAA"
                [formGroup]="filterForm.controls.dateRange">
              </app-date-range-picker>

              <app-data-table-multi-select-filter formControlName="type" label="Tipo" [options]="typeFilterOptions"></app-data-table-multi-select-filter>
              <app-data-table-multi-select-filter formControlName="event" label="Evento" [options]="eventSelectOptions"></app-data-table-multi-select-filter>
              <app-data-table-multi-select-filter formControlName="location" label="Lugar" [options]="locationSelectOptions"></app-data-table-multi-select-filter>

            </div>
          </div>
        </app-table-surface>
      </div>

      <ng-template #eventMovementsDetail let-row="row" let-view="view">
        <div [id]="'event-movements-' + view + '-' + row.id">
          <app-person-event-effects [event]="row" [collapsible]="false"></app-person-event-effects>
        </div>
      </ng-template>

      <ng-template #timelineView>
        <section class="timeline-view" aria-label="Timeline de eventos">
          <div *ngIf="filteredEvents.length === 0" class="timeline-empty">
            Esta persona todavÃ­a no tiene eventos cargados para el filtro seleccionado.
          </div>

          <ol *ngIf="filteredEvents.length > 0" class="events-timeline">
            <li
              *ngFor="let event of filteredEvents; trackBy: trackByEvent"
              class="events-timeline__item"
              [ngClass]="'events-timeline__item--' + getCategoryTheme(event.category)">
              <div class="events-timeline__marker" aria-hidden="true">
                <mat-icon>{{ event.category === 'MinisterialActivity' ? 'volunteer_activism' : event.category === 'ReligiousEvent' ? 'auto_awesome' : 'groups' }}</mat-icon>
              </div>

              <article class="events-timeline__content">
                <div class="events-timeline__main">
                  <div class="events-timeline__date">
                    <span>{{ event.eventDate | date: 'longDate' }}</span>
                    <span *ngIf="event.endDate">hasta {{ event.endDate | date: 'longDate' }}</span>
                  </div>

                  <div class="events-timeline__body">
                    <span class="type-badge" [ngClass]="'type-badge--' + getCategoryTheme(event.category)">
                      {{ event.categoryName }}
                    </span>
                    <div class="events-timeline__title">{{ getEventDisplayName(event) }}</div>
                    <div *ngIf="getEventDisplayDetail(event) as detail" class="events-timeline__detail">{{ detail }}</div>
                    <app-person-event-effects *ngIf="event.eventTypeKey === 'AppointmentAssignment'" [event]="event"></app-person-event-effects>
                    <ng-container *ngIf="getRelatedPersonDisplay(event) as relatedPerson">
                      <app-member-reference
                        [personId]="canLinkRelatedPerson(event) ? event.relatedPersonId : null"
                        [name]="relatedPerson">
                      </app-member-reference>
                    </ng-container>

                    <div class="events-timeline__meta">
                      <ng-container *ngIf="getEventUnits(event) as units">
                        <span *ngIf="units.length" class="events-timeline__meta-item">
                          <mat-icon>account_tree</mat-icon>
                          <ng-container *ngFor="let unit of units; let last = last">
                            <button
                              *ngIf="unit.id; else plainTimelineUnit"
                              mat-button
                              type="button"
                              class="events-timeline__inline-button"
                              (click)="navigateToUnit(unit.id)">
                              {{ unit.name }}
                            </button>
                            <ng-template #plainTimelineUnit>{{ unit.name }}</ng-template><span *ngIf="!last">, </span>
                          </ng-container>
                        </span>
                      </ng-container>

                      <span *ngIf="getEventLocation(event) as location" class="events-timeline__meta-item">
                        <mat-icon>place</mat-icon>
                        <a
                          *ngIf="getEventLocationUnitId(event) as unitId; else plainTimelineLocation"
                          class="events-timeline__link"
                          [routerLink]="['/units', unitId]">
                          {{ location }}
                        </a>
                        <ng-template #plainTimelineLocation>{{ location }}</ng-template>
                      </span>
                    </div>

                    <div *ngIf="event.notes" class="events-timeline__notes">{{ event.notes }}</div>
                  </div>
                </div>

                <div *ngIf="canManageEvent(event) && (event.canEdit || event.canDelete)" class="events-timeline__actions">
                  <button
                    *ngIf="event.canEdit"
                    mat-icon-button
                    type="button"
                    [attr.aria-label]="event.category === 'MinisterialActivity' ? 'Corregir evento ministerial' : 'Editar evento'"
                    [attr.title]="event.category === 'MinisterialActivity' ? 'Corregir evento ministerial' : 'Editar evento'"
                    (click)="onEditEvent(event)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    *ngIf="event.canDelete"
                    mat-icon-button
                    color="warn"
                    type="button"
                    aria-label="Eliminar evento"
                    title="Eliminar evento"
                    (click)="onDelete(event)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </article>
            </li>
          </ol>
        </section>
      </ng-template>

      <div class="events-table">
        <ng-template #cellContent let-column="column" let-row="row" let-view="view">
          <ng-container *ngIf="column === 'eventDate'">
            <div>{{ row.eventDate | date: 'longDate' }}</div>
            <div *ngIf="row.endDate" class="date-secondary">
              hasta {{ row.endDate | date: 'longDate' }}
            </div>
          </ng-container>

          <ng-container *ngIf="column === 'category'">
            <span class="type-badge" [ngClass]="'type-badge--' + getCategoryTheme(row.category)">
              {{ row.categoryName }}
            </span>
          </ng-container>

          <ng-container *ngIf="column === 'eventType'">
            <div class="event-type-cell">
              <span class="event-type-name">{{ getEventDisplayName(row) }}</span>
              <span *ngIf="getEventDisplayDetail(row) as detail" class="event-type-detail">{{ detail }}</span>
              <button *ngIf="eventMovements(row).length" type="button" class="event-movements-toggle"
                [attr.aria-expanded]="expandedEvent === row" [attr.aria-controls]="'event-movements-' + view + '-' + row.id"
                (click)="$event.stopPropagation(); toggleEventMovements(row)">
                <mat-icon>{{ expandedEvent === row ? 'expand_less' : 'expand_more' }}</mat-icon>
                Ver movimientos · {{ eventMovements(row).length }}
              </button>
              <ng-container *ngIf="getRelatedPersonDisplay(row) as relatedPerson">
                <app-member-reference
                  [personId]="canLinkRelatedPerson(row) ? row.relatedPersonId : null"
                  [name]="relatedPerson"
                  [stopPropagation]="true">
                </app-member-reference>
              </ng-container>
            </div>
          </ng-container>

          <ng-container *ngIf="column === 'unit'">
            <div class="unit-cell">
              <ng-container *ngIf="getEventUnits(row) as units">
                <ng-container *ngIf="units.length; else noUnit">
                  <ng-container *ngFor="let unit of units; let last = last">
                    <a
                      *ngIf="unit.id; else historicalUnit"
                      class="unit-link unit-cell__link"
                      [href]="'/units/' + unit.id"
                      (pointerdown)="onUnitPointerDown($event, unit.id)">
                      {{ unit.name }}
                    </a>
                    <ng-template #historicalUnit>{{ unit.name }}</ng-template><span *ngIf="!last">, </span>
                  </ng-container>
                </ng-container>
                <ng-template #noUnit>-</ng-template>
              </ng-container>
            </div>
          </ng-container>

          <ng-container *ngIf="column === 'location'">
            <div class="location-cell">
              <ng-container *ngIf="getEventLocation(row) as location; else noLocation">
                <a
                  *ngIf="getEventLocationUnitId(row) as unitId; else plainLocation"
                  class="location-link"
                  [routerLink]="['/units', unitId]"
                  (click)="$event.stopPropagation()">
                  {{ location }}
                </a>
                <ng-template #plainLocation>{{ location }}</ng-template>
              </ng-container>
              <ng-template #noLocation>-</ng-template>
            </div>
          </ng-container>

          <span *ngIf="column === 'notes'" class="notes-cell">{{ row.notes || '-' }}</span>

          <ng-container *ngIf="column === 'actions'">
            <div class="actions-cell">
              <div class="actions-cell__buttons">
                <button
                  *ngIf="canManageEvent(row) && row.canEdit"
                  mat-icon-button
                  type="button"
                  [attr.aria-label]="row.category === 'MinisterialActivity' ? 'Corregir evento ministerial' : 'Editar evento'"
                  [attr.title]="row.category === 'MinisterialActivity' ? 'Corregir evento ministerial' : 'Editar evento'"
                  (click)="$event.stopPropagation(); onEditEvent(row)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button *ngIf="canManageEvent(row) && row.canDelete" mat-icon-button color="warn" type="button" (click)="$event.stopPropagation(); onDelete(row)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </div>

      <div *ngIf="viewMode === 'table' && filteredEvents.length === 0" class="empty-state mobile-empty-state">
        <mat-icon>event_busy</mat-icon>
        <p>Esta persona todavía no tiene eventos cargados para el filtro seleccionado.</p>
      </div>

      <div class="event-cards" *ngIf="viewMode === 'table' && filteredEvents.length > 0">
        <div *ngFor="let event of filteredEvents; trackBy: trackByEvent" class="event-card">
          <div class="event-card-main">
            <div class="event-card-info">
              <span class="type-badge" [ngClass]="'type-badge--' + getCategoryTheme(event.category)">
                {{ event.categoryName }}
              </span>
              <span class="event-card-type">{{ getEventDisplayName(event) }}</span>
              <span *ngIf="getEventDisplayDetail(event) as detail" class="event-card-detail">{{ detail }}</span>
              <ng-container *ngIf="getRelatedPersonDisplay(event) as relatedPerson">
                <app-member-reference
                  [personId]="canLinkRelatedPerson(event) ? event.relatedPersonId : null"
                  [name]="relatedPerson">
                </app-member-reference>
              </ng-container>
              <span class="event-card-date">{{ event.eventDate | date: 'dd/MM/yyyy' }}</span>
              <ng-container *ngIf="getEventLocation(event) as location">
                <a
                  *ngIf="getEventLocationUnitId(event) as unitId; else plainCardLocation"
                  class="event-card-location event-card-location--link"
                  [routerLink]="['/units', unitId]">
                  {{ location }}
                </a>
                <ng-template #plainCardLocation>
                  <span class="event-card-location">{{ location }}</span>
                </ng-template>
              </ng-container>
              <span *ngIf="event.notes" class="event-card-notes">{{ event.notes }}</span>
            </div>

            <div class="event-card-actions">
              <button
                *ngIf="canManageEvent(event) && event.canEdit"
                mat-icon-button
                type="button"
                [attr.aria-label]="event.category === 'MinisterialActivity' ? 'Corregir evento ministerial' : 'Editar evento'"
                [attr.title]="event.category === 'MinisterialActivity' ? 'Corregir evento ministerial' : 'Editar evento'"
                (click)="onEditEvent(event)">
                <mat-icon>edit</mat-icon>
              </button>
              <button *ngIf="canManageEvent(event) && event.canDelete" mat-icon-button color="warn" type="button" (click)="onDelete(event)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
